import React, { useMemo, useState } from 'react';
import { Layout, Card, Button, Input, Radio, Popconfirm } from 'antd';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useSelector } from 'react-redux';
import CustomThemeDrawer from '../../../../../Elements/CustomThemeDrawer';
import { EditOutlined, DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';
 
const { Content } = Layout


const alerts = ['e-Mail', 'SMS', 'WhatsApp', 'Mobile App'];
const subCategories = [
  'Daily Report',
  'Monthly Report',
  'Steam Report',
  'Comm Alerts',
  'Data Alerts',
];

const recipientData = Array.from({ length: 9 }, (_, i) => ({
  sno: i + 1,
  recipient: i % 2 === 0 ? 'abc@gmail.com' : 'def@gmail.com',
}));

const ManualData = () => { 
      const [open, setOpen] = useState(false); 
      const [open2, setOpen2] = useState(false); 
    
    const showDrawer = () => {
        setOpen(true);
      };
    
      const onClose = () => {
        setOpen(false);
      };
    const showDrawer2 = () => {
        setOpen2(true);
      };
    
      const onClose2 = () => {
        setOpen2(false);
      };
    const mode = useSelector((state) => state.darkMode);
const color = useSelector((state) => state.ThemeChange);
console.log(color);
const { isdarkMode } = mode;
const externalEnergySources = [
    { sno: 1, name: 'Solar' },
    { sno: 2, name: 'Wind' },
    { sno: 3, name: 'Solar' },
  ];
  
  const productionData = [
    { sno: 1, name: 'Crushing' },
    { sno: 2, name: 'Tyres' },
  ];
  
  const emissionDetails = [
    { sno: 1, name: 'HSD' },
    { sno: 2, name: 'SKO' },
  ];
  
  const externalEnergyCols = [
    { headerName: 'S.No', field: 'sno', width: 80 },
    { headerName: 'External Energy Source', field: 'name', flex: 1 },
    {
      headerName: 'RE: 3rd Party',
      field: 're3',
      cellRenderer: () => <Radio />,
      width: 120,
    },
    {
      headerName: 'RE: Plant',
      field: 'rePlant',
      cellRenderer: () => <Radio />,
      width: 100,
    },
    {
      headerName: 'Utility',
      field: 'utility',
      cellRenderer: () => <Radio />,
      width: 100,
    },
    {
      headerName: "Actions",
      width: 150,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            {/* <Button
            //   onClick={() => {
            //     params.data.actions.update(params.data);
            //   }}
            >
              <EditOutlined />
            </Button> */}

            <Popconfirm
              title="Are you sure to delete this Converter"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => console.log(params.data.siteID)}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];
  
  const productionCols = [
    { headerName: 'S.No', field: 'sno', width: 80 },
    { headerName: 'Production Data', field: 'name', flex: 1 },
    {
        headerName: "Actions",
        width: 150,
        cellRenderer: (params) => {
          return (
            <div className="space-x-2">
              {/* <Button
              //   onClick={() => {
              //     params.data.actions.update(params.data);
              //   }}
              >
                <EditOutlined />
              </Button> */}
  
              <Popconfirm
                title="Are you sure to delete this Converter"
                // description="Are you sure to delete this Converter Configuration?"
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                onConfirm={() => console.log(params.data.siteID)}
                trigger="click"
              >
                <Button className="text-red-500">
                  <DeleteOutlined />
                </Button>
              </Popconfirm>
            </div>
          );
        },
      },
  ];
  
  
  const emissionCols = [
    { headerName: 'S.No', field: 'sno', width: 80 },
    { headerName: 'Emission Details', field: 'name', flex: 1 },
    {
        headerName: "Actions",
        width: 150,
        cellRenderer: (params) => {
          return (
            <div className="space-x-2">
              {/* <Button
              //   onClick={() => {
              //     params.data.actions.update(params.data);
              //   }}
              >
                <EditOutlined />
              </Button> */}
  
              <Popconfirm
                title="Are you sure to delete this Converter"
                // description="Are you sure to delete this Converter Configuration?"
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                onConfirm={() => console.log(params.data.siteID)}
                trigger="click"
              >
                <Button className="text-red-500">
                  <DeleteOutlined />
                </Button>
              </Popconfirm>
            </div>
          );
        },
      },
  ];
  
  



  return (
<div className={`p-4 min-h-screen  ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}>
  <div>
    <h2
      className={`pb-0 text-left text-3xl font-[500] ml-0 tracking-[1px] ${
        isdarkMode ? "text-white" : "text-black"
      }`}
    >
      Manual Entry
    </h2>

    <div className="flex gap-4 h-[90vh]">
  {/* External Energy Sources */}
  <Card
    title={<span className={isdarkMode ? "text-white" : "text-black"}>External Energy Sources</span>}
    extra={<Button type="primary" onClick={()=>showDrawer()}>Add +</Button>}
    className={`w-2/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
    bodyStyle={{ padding: 0 }}
  >
    <div className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
    style={{
      '--ag-header-background-color': color.themeConfig.colorPrimary,
      '--ag-header-foreground-color': '#fff',
      '--ag-header-group-bg': color.themeConfig.colorPrimaryShade, // custom var
      height: "80vh", width: "100%", overflowY: "auto"
    }}>
      <AgGridReact rowData={externalEnergySources} columnDefs={externalEnergyCols} domLayout="normal"
      rowHeight={50} /> 
    </div>
  </Card>

  {/* Production Data */}
  <Card
    title={<span className={isdarkMode ? "text-white" : "text-black"}>Production Data</span>}
    extra={<Button type="primary" onClick={()=>showDrawer2()}>Add +</Button>}
    className={`w-1/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
    bodyStyle={{ padding: 0 }}
  >
    <div className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
    style={{
      '--ag-header-background-color': color.themeConfig.colorPrimary,
      '--ag-header-foreground-color': '#fff',
      '--ag-header-group-bg': color.themeConfig.colorPrimaryShade, // custom var
      height: "80vh", width: "100%", overflowY: "auto"
    }}>
      <AgGridReact rowData={productionData} columnDefs={productionCols} domLayout="normal" />
    </div>
  </Card>

  {/* Emission Details */}
  <Card
    title={<span className={isdarkMode ? "text-white" : "text-black"}>Emission Details</span>}
    extra={<Button type="primary">Add +</Button>}
    className={`w-1/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
    bodyStyle={{ padding: 0 }}
  >
    <div className={`ag-theme-alpine${isdarkMode ? "-dark" : ""}`} style={{ height: 500 }}>
      <AgGridReact rowData={emissionDetails} columnDefs={emissionCols} domLayout="normal" />
    </div>
  </Card>
</div>

  </div>

  <CustomThemeDrawer
   title="Close"
   showDrawer={showDrawer}
   open={open}
   onClose={onClose}
  >
    <div className="flex flex-col gap-6 mt-2">
        <div>
          <label className="block mb-2 font-medium">
          Add External Energy Sources
          </label>
          <Input
            placeholder="Enter External Energy Sources..."
            // value={alertName}
            // onChange={(e) => setAlertName(e.target.value)}
            className={`${isdarkMode ? 'darkmode-input' : ''}`}
          />
        </div>

        <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
          <Button onClick={onClose} className="">
            Cancel
          </Button>
          <Button
            type="primary"
            // disabled={!alertName.trim()}
            // onClick={handleAdd}
          >
            Add
          </Button>
        </div>
      </div>
  </CustomThemeDrawer>
  <CustomThemeDrawer
   title="Close"
   showDrawer={showDrawer2}
   open={open2}
   onClose={onClose2}
  >
    <div className="flex flex-col gap-6 mt-2">
        <div>
          <label className="block mb-2 font-medium">
           Add Production Data
          </label>
          <Input
            placeholder="Enter Production Data.."
            // value={alertName}
            // onChange={(e) => setAlertName(e.target.value)}
            className={`${isdarkMode ? 'darkmode-input' : ''}`}
          />
        </div>

        <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
          <Button onClick={onClose} className="">
            Cancel
          </Button>
          <Button
            type="primary"
            // disabled={!alertName.trim()}
            // onClick={handleAdd}
          >
            Add
          </Button>
        </div>
      </div>
  </CustomThemeDrawer>
</div>

  );
};

export default ManualData;
